export const all_routes = {
  // Dashboard & bussiness routes
  dashboardWebsite: "/website-dashboard",

  // Company Info
  termCondition: "/website-dashboard/term-condition",
  moreDetails: "/website-dashboard/more-details",
  googleMap: "/website-dashboard/google-map",
  socialMedia: "/website-dashboard/social-media",

  // User Management
  regissterLoginInfo: "/website-dashboard/regisster-login-info",
  forgetPassword: "/website-dashboard/forget-password",
  manageVendorRegisterInfo: "/website-dashboard/register",
  columnApproval: "/website-dashboard/column-approval",
  contactRequest: "/website-dashboard/contact-request",

  // E-commerce
  rating: "/website-dashboard/rating",
  specialOffer: "/website-dashboard/special-offer",
  orderEnquery: "/website-dashboard/order-enquery",
  cart: "/website-dashboard/cart",
  wishList: "/website-dashboard/wish-list",
  customers: "/website-dashboard/customers",
  billingShipping: "/website-dashboard/billing-shiping",

  // Media & Content
  runingText: "/website-dashboard/runing-text",
  catelogue: "/website-dashboard/catelogue",
  news: "/website-dashboard/news",
  newsLetter: "/website-dashboard/news-letter",
  bannerSlider: "/website-dashboard/slider",
  team: "/website-dashboard/team",
  gallary: "/website-dashboard/gallary",
  appLogo: "/website-dashboard/app-logo",

  // Support
  aboutUs: "/website-dashboard/about-us",
  contactUs: "/website-dashboard/contact-us",
  feedback: "/website-dashboard/feedback",
  faq: "/website-dashboard/faq",

  backend: {
    // Feedback
    feedback: "/getFeedback",
    deleteFeedback: "/deleteFeedback",

    // FAQ
    addUpdateFaq: "/addUpdateFaq",
    getFaq: "/getFaq",
    deleteFaq: "/deleteFaq",

    // Column approval
    addUpdateColumnApproval: "/addUpdateColumnApproval",
    getColumnApproval: "/getColumnApproval",
    deleteColumnApproval: "/deleteColumnApproval",

    // Catelogue
    addUpdateCatelogue: "/addUpdateCatelogue",
    getCatelogue: "/getCatelogue",
    deleteCatelogue: "/deleteCatelogue",

    // Runing Text
    addUpdateRuningText: "/addUpdateRuningText",
    getRuningText: "/getRuningText",
    deleteRuningText: "/deleteRuningText",

    // App Logo
    addUpdateAppLogo: "/addUpdateAppLogo",
    getAppLogo: "/getAppLogo",
    deleteAppLogo: "/deleteAppLogo",

    // Our Team
    addUpdateOurTeam: "/addUpdateOurTeam",
    getOurTeam: "/getOurTeam",
    deleteOurTeam: "/deleteOurTeam",

    // Gallary
    addUpdateGallary: "/addUpdateGallary",
    getGallary: "/getGallary",
    deleteGallary: "/deleteGallary",

    // Slider
    addUpdateSlider: "/addUpdateSlider",
    getSlider: "/getSlider",
    deleteSlider: "/deleteSlider",

    // Blog
    addUpdateBlog: "/addUpdateBlog",
    getBlog: "/getBlog",
    deleteBlog: "/deleteBlog",

    // About US
    addUpdateAboutUs: "/addUpdateAboutUs",
    getAboutUs: "/getAboutUs",

    // Conatct US
    addUpdateContactUs: "/addUpdateContactUs",
    getContactUs: "/getContactUs",
    deleteContactUs: "/deleteContactUs",

    // Term Condition
    addUpdateTermCondition: "/addUpdateTermCondition",
    getTermCondition: "/getTermCondition",

    // News Letter
    addUpdateNewsLetter: "/addUpdateNewsLetter",
    getNewsLetter: "/getNewsLetter",
    deleteNewsLetter: "/deleteNewsLetter",

    // Google map
    addUpdateGoogleMap: "/addUpdateGoogleMap",
    getGoogleMap: "/getGoogleMap",

    // Social Media
    addUpdateSocialMedia: "/addUpdateSocialMedia",
    getSocialMedia: "/getSocialMedia",
    deleteSocialMedia: "/deleteSocialMedia",

    // Forget password
    getForgetPassword: "/getForgetPassword",
    deleteForgetPassword: "/deleteForgetPassword",

    // Web user
    addUpdateWebUser: "/addUpdateWebUser",
    getWebUser: "/getWebUser",
    deleteWebUser: "/deleteWebUser",

    // Billing Address
    addUpdateAddress: "/addUpdateAddress",
    getAddress: "/getAddress",
    deleteAddress: "/deleteAddress",

    // Contact US Request
    getContactUsRequest: "/getContactUsRequest",
    deleteContactUsRequest: "/deleteContactUsRequest",

    // Cart details
    getCartList: "/getCartList",
    getCartDetails: "/getCartDetails",
    removeCart: "/removeCart",

    // WishList details
    getList: "/getList",
    getDetails: "/getDetails",
    remove: "/remove",

    // EnquiryList details
    getEnquiryList: "/getEnquiryList",
    getEnqueryDetails: "/getEnqueryDetails",
    removeEnquery: "/removeEnquery",

    // Offer
    addUpdateOffer: "/addUpdateOffer",
    listOffers: "/listOffers",
    deleteOffer: "/deleteOffer",
    showOffer: "/showOffer",

    // Review Rating
    addReview: "/addReview",
    deleteReview: "/deleteReview",
    listReview: "/listReview",
    approveReview: "/approveReview",
    rating: "/rating",
  },
};
